import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import Swal from 'sweetalert2'
import { LocalstorageService } from '../../services/localstorage.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormsService } from 'src/app/services/forms.service';
import { forkJoin, from, map, Observable, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { ContentService } from 'src/app/services/content.service';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { UserInformationService } from 'src/app/services/user-information.service';
import { AuthService } from 'src/app/services/auth.service';
import { emailFormatValidator } from 'src/app/shared/functions';

@Component({
  selector: 'app-configuration',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent {
  configurationForm: FormGroup;
  userProfile: any;
  imgUser:string | null = '';
  userNameOrPasschanged: boolean = false;
  hide:boolean = true;
  hideConfirm:boolean = true;
  hideCurrent: boolean = true;
  password:string = '';
  confirmPassword:string = '';
  submitted:boolean = false;
  error?: string;
  formTypes: any;
  filename: string = '';
  gender: string = '';
  company: string = '';
  currentFragment: string | null = '';
  userExists: boolean = false;
  mailExists: boolean = false;
  passWrited: boolean = false;
  mailChanged: boolean = false;
  currentPassRequired: boolean = false;
  idFile: string = '';
  documentFile: any;
  documentFileBinary: any;
  forgotPass: boolean = false;
  MAX_SIZE_FILE=2000000;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor( private router:Router, private localStorage: LocalstorageService, private forms:FormsService, private route:ActivatedRoute, private contentService: ContentService,
    private userService: UserProfileService, private userService2: UserInformationService, private authService: AuthService) {
    this.configurationForm = new FormGroup({
      field_name: new FormControl(null, Validators.required),
      field_lastname: new FormControl(null, Validators.required),
      field_document_type: new FormControl(''),
      field_document: new FormControl(),
      field_birthdate: new FormControl(),
      field_gender: new FormControl(''),
      field_country: new FormControl(),
      field_city: new FormControl(),
      field_profession: new FormControl(),
      field_profile: new FormControl(),
      field_company: new FormControl(''),
      name: new FormControl(null, Validators.minLength(8)),
      mail: new FormControl('', [Validators.required, Validators.email, emailFormatValidator]),
      pass: new FormControl(null, Validators.minLength(8)),
      confirmPassword: new FormControl(),
      current_pass: new FormControl(),
      user_picture: new FormControl()
    });

    this.configurationForm.get('current_pass')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.forgotPass = false;
      this.submitted = false;
    })

    this.configurationForm.get('name')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.userExists = false;
      this.submitted = false;
    })
    this.configurationForm.get('mail')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.mailExists = false;
      this.submitted = false;
    })
  }

  ngOnInit() {
    if (this.localStorage.getItem('profile_current_user')) {
      this.loadUserFromLocalStorage();
      this.loadFormValuesFromServer();
    } else {
      setTimeout(() => {
        this.loadUserFromLocalStorage();
      }, 1500);
    }
    this.route.fragment.pipe(takeUntil(this.destroy$)).subscribe(fragment => {
      this.currentFragment = fragment;
    });
    this.loadDataProfile();
    this.loadFormTypes();
  }

  canDeactivate(): Observable<boolean> {
    if (this.submitted) {
        return of(true);
    }
    if (this.configurationForm.dirty) {
      return from(
          Swal.fire({
              title: '¿Quieres guardar los cambios realizados?',
              color: '#4F0B7B',
              showDenyButton: true,
              showCancelButton: true,
              confirmButtonText: 'Guardar',
              confirmButtonColor: '#4F0B7B',
              denyButtonText: `No guardar`,
              denyButtonColor: '#F0B853',
              cancelButtonText: 'Cancelar',
              cancelButtonColor: '#858585'
          }).then((result) => {
              if (result.isConfirmed) {
                this.submitted = true;
                this.onSubmit();
                return false;
              } else if (result.isDenied) {
                this.submitted = true;
                return true;
              } else {
                return false;
              }
          })
      );
    }
    return of(true);
  }

  loadUserFromLocalStorage() {
    this.userProfile = this.localStorage.getCurrentUserProfileAsJson();
    this.imgUser = this.localStorage.getItem('userImg');
  }

  loadFormValuesFromServer() {
    console.log(this.userProfile);
    const idDoc = this.userProfile.relationships.field_document_type.data.id;
    const idGen = this.userProfile.relationships.field_gender.data.id;
    const idComp = this.userProfile.relationships.field_company.data ? this.userProfile.relationships.field_company.data.id : '';

    forkJoin({
      doc: this.forms.getDocumentTypeById(idDoc),
      gen: this.forms.getGenderById(idGen),
      comp: this.forms.getcompanyById(idComp)
    }).pipe(takeUntil(this.destroy$)).subscribe(
      {
        next: results => {
          this.confiForm['field_document_type'].setValue(results.doc.id);
          this.confiForm['field_gender'].setValue(results.gen.id);
          this.confiForm['field_company'].setValue(results.comp.id);
        },
        error: error => {
          console.error('Error trayendo las taxonomías del server', error)
        }
      }
    );
  }

  loadFormTypes() {
    this.forms.getFieldsTypes().pipe(takeUntil(this.destroy$)).subscribe(
      {
        next: data => {
          this.formTypes = data;
        },
        error: error => {
          console.error('Error trayendo los campos de taxonomía', error)
        }
      }
    );
  }

  setDefaultImage(event:any) {
    event.target.src = '../../../assets/images/user.png';
  }

  get confiForm() { return this.configurationForm.controls; }

  loadDataProfile(){
    if (this.userProfile) {
      this.configurationForm.patchValue(
        {
          field_name: this.userProfile.attributes.field_name,
          field_lastname: this.userProfile.attributes.field_lastname,
          field_document: this.userProfile.attributes.field_document,
          field_birthdate: this.userProfile.attributes.field_birthdate,
          field_profile: this.userProfile.attributes.field_profile,
          field_country: this.userProfile.attributes.field_country,
          field_city: this.userProfile.attributes.field_city,
          field_profession: this.userProfile.attributes.field_profession,
          name: this.userProfile.attributes.name,
          mail: this.userProfile.attributes.mail,
        }
      );
    }
  }

  restoreFields(){
    this.loadDataProfile();
    this.loadFormValuesFromServer();
    this.mailChanged = false;
    this.currentPassRequired = false;
    this.configurationForm.markAsPristine();
  }

  onSubmit() {
    this.submitted = true;
    this.error = '';
    if (this.configurationForm.invalid) {
      return;
    }
    const formValue = this.configurationForm.value;
    const csrf_token = this.localStorage.getItem('login_csrf_token_edutegia');
    const { name, field_name, field_lastname, field_city, field_birthdate, field_document, field_country, field_profession, field_profile } = formValue;

    const formData: any = {
      data: {
        type: 'user--user',
        id: this.userProfile.id,
        attributes: {name, field_name, field_lastname, field_city, field_birthdate, field_document, field_country, field_profession, field_profile},
        relationships: {
          field_document_type: {
            data: {
              type: 'taxonomy_term--document_type',
              id: this.configurationForm.get('field_document_type')?.value
            }
          },
          field_company: {
            data: {
              type: 'taxonomy_term--company',
              id: this.configurationForm.get('field_company')?.value
            }
          },
          field_gender: {
            data: {
              type: 'taxonomy_term--gender',
              id: this.configurationForm.get('field_gender')?.value
            }
          }
        }
      }
    }

    if (this.configurationForm.get('mail')?.dirty) {
      this.mailChanged = true;
      formData.data.attributes.mail = formValue.mail;
    }

    if (this.configurationForm.get('pass')?.dirty || this.configurationForm.get('current_pass')?.dirty) {
      this.currentPassRequired = true;
      formData.data.attributes.pass = {
          existing: formValue.current_pass,
          value: formValue.pass
      };
    }

    let uploadImage$;

    if (this.configurationForm.get('user_picture')?.value) {
      if (this.documentFile && this.documentFileBinary) {
        uploadImage$ = this.contentService.uploadImage(this.documentFile, this.documentFileBinary);
      }
    } else {
      uploadImage$ = of(null);
    }

    uploadImage$?.pipe(
      takeUntil(this.destroy$),
      switchMap(resp => {
        console.log('Respuesta de uploadImage$', resp);
          if (resp) {
              const idFile: string = resp.id;
              formData.data.relationships.user_picture = {
                  data: {
                      type: "file--file",
                      id: idFile
                  }
              };
          }
          console.log('hola');
          return this.userService.updateProfile(formData, this.userProfile.id, csrf_token);
        })
      ).subscribe(
        {
          next: () => {
          console.log('hola subs');
          if(this.configurationForm.get('name')?.dirty || this.configurationForm.get('pass')?.dirty) {
            Swal.fire({
              title: 'Actualización exitosa',
              color: '#858585',
              text: 'Debido a los cambios realizados, necesitas iniciar sesión nuevamente.',
              icon: 'success',
              iconColor: '#4F0B7B',
              confirmButtonText: 'Continuar',
              confirmButtonColor: '#4F0B7B',
            }).then((result) => {
              if (result.isConfirmed || result.dismiss === Swal.DismissReason.backdrop) {
                this.authService.logoutWithCookie(localStorage.getItem('logout_token_edutegia'),
                localStorage.getItem('global_token_edutegia')).pipe(takeUntil(this.destroy$))
                .subscribe(
                  {
                    next: (resp:any) => {
                      if(resp===null){
                        this.router.navigate(['/login']);
                      }
                    },
                    error : error => {
                      console.error('Error cerrando sesión', error)
                    }
                  }
                );
              }
            });
          }else {
            this.userService2.getUserProfile(this.userProfile.id).pipe(
              takeUntil(this.destroy$),
              tap(resp => {
                this.localStorage.setItem('profile_current_user', JSON.stringify(resp));
              }),
              map(() => this.localStorage.getCurrentUserProfileAsJson()),
              switchMap(user => {
                if (user.relationships.user_picture?.data) {
                  const idImgUser = user.relationships.user_picture.data.id;
                  return this.contentService.getFileContent(idImgUser);
                }
                return of(null);
              })
            ).subscribe(
              {
                next:imgUser => {
                  if (imgUser) {
                    this.localStorage.setItem('userImg', imgUser.url);
                  }
                  Swal.fire({
                    icon: 'success',
                    iconColor: '#4F0B7B',
                    title: 'Perfil actualizado',
                    color: '#858585',
                    text: 'Sus datos se han actualizado correctamente',
                    confirmButtonText: 'Continuar',
                    confirmButtonColor: '#4F0B7B',
                  }).then((result) => {
                    if (result.isConfirmed || result.dismiss === Swal.DismissReason.backdrop) {
                      this.submitted = false;
                      this.restoreFields();
                      this.loadDataProfile();
                      this.router.navigate(['/zona-de-aprendizaje']);
                    }
                  });
                },
                error: error => {
                  console.error('Error trayendo el perfil del usuario', error)
                }
              }
            );
          }
        },
        error: error => {
          // this.submitted = false;
          if (error.status === 422 && error.error && error.error.errors) {
            let errorMsg = '';
            for (let err of error.error.errors) {
                if (err.source.pointer === "/data/attributes/name") this.userExists = true;
                if (err.source.pointer === "/data/attributes/mail"){
                  if (err.detail.includes("mail: The email address")) {
                    this.mailExists = true;
                  } else if (err.detail.includes("Su contraseña actual es incorrecta")) {
                    this.submitted = true;
                    this.forgotPass = true;
                  }
                }
                if (err.source.pointer === "/data/attributes/pass" && err.detail.includes("pass: Su contraseña actual es incorrecta")) this.submitted = true; this.forgotPass = true;
            }
          }
        }
      }


    )

  }

  onFileSelected(event: any): void {
    if(event.target.files.length > 0){
      this.documentFile = event.target.files[0];
      this.documentFileBinary = event.target.files[0];

      if(this.documentFileBinary.type != 'image/jpeg' && this.documentFileBinary.type != 'image/png' ){
        Swal.fire({
          icon: 'warning',
          iconColor: '#FCB424',
          title: 'Error de formato',
          color: '#858585',
          text: 'La imagen debe ser formato JPG o PNG',
          confirmButtonColor: '#4F0B7B'
        })
        return;
      }

      if(this.documentFile.size > this.MAX_SIZE_FILE){
        Swal.fire({
          icon: 'warning',
          iconColor: '#FCB424',
          title: 'Archivo muy pesado',
          color: '#858585',
          text: 'La imágen debe ser menor o igual a 2Mb de tamaño para ser valido.',
          confirmButtonColor: '#4F0B7B'
        })
        return;
      }

      this.filename = this.documentFile.name;

      Swal.fire({
        icon: 'success',
        iconColor: '#4F0B7B',
        title: 'Imagen cargada',
        color: '#858585',
        text: 'La imagen se ha cargado correctamente. Guarda los cambios para verlos reflejados',
        confirmButtonColor: '#4F0B7B'
      });
    }
  }

  toggleHide() {
    this.hide = !this.hide;
  }

  toggleHideCurrent() {
    this.hideCurrent = !this.hideCurrent;
  }

  toggleHideConfirm() {
    this.hideConfirm = !this.hideConfirm;
  }

  passwordsMatch(): boolean {
    return this.configurationForm.value.pass === this.configurationForm.value.confirmPassword;
  }

}
